export const formatDate = (dateString: string) => {
    if (!dateString || dateString.length !== 8) return 'Invalid Date';

    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);

    const date = new Date(`${year}-${month}-${day}`);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
};

export const formatReviewDateTime = (
    reviewDate?: string,
    reviewTime?: string
): string => {
    if (
        !reviewDate ||
        !reviewTime ||
        reviewDate.length !== 8 ||
        reviewTime.length < 6
    ) {
        return '-';
    }

    const year = reviewDate.slice(0, 4);
    const month = reviewDate.slice(4, 6);
    const day = reviewDate.slice(6, 8);

    const hours = reviewTime.slice(0, 2);
    const minutes = reviewTime.slice(2, 4);

    return `${day}/${month}/${year} ${hours}:${minutes}`;
};
